var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('div',{attrs:{"align":"middle","type":"flex","justify":"center"}},[_c('el-card',{staticClass:"el-card"},[_c('download-go')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }